import React from 'react';
import { TableOfContentsDto } from '../../interfaces/TableOfContentsDto';
import transformData from './transformData';
import Resource, { ResourceInfo, ResourceProps } from '../Resource/Resource/Resource';

export const TableOfContentsResourceInfo: ResourceInfo = {
  name: '/App.tableOfContentsResource',
  dataDst: '/App.tableOfContentsData',
};

export interface TableOfContentsResourceProps<Data, Error> extends ResourceProps<Data, Error> {
  tableOfContentName: string;
}

const TableOfContentsResource = <Data, Error = {}>({ tableOfContentName, ...props }: TableOfContentsResourceProps<Data, Error>) => {
  const finalResourceInfo = { ...TableOfContentsResourceInfo };
  finalResourceInfo.dataDst += `-${tableOfContentName}`;
  finalResourceInfo.name += `-${tableOfContentName}`;

  return (
    <Resource
      {...finalResourceInfo}
      {...props}
      transformResponse={(tableOfContentsDto: TableOfContentsDto) => transformData(tableOfContentsDto)}
    />
  );
};
export default TableOfContentsResource;
